import * as React from "react";
import { forwardRef, memo } from "react";
const SvgUp = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 14 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: props.className, ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 7L7 1L1 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgUp);
const Memo = memo(ForwardRef);
export default Memo;
